<template>
  <modal
    name="modal-reject-alarm"
    height="auto"
    width="20%"
    class="customSurveyModal"
    :scrollable="true"
    @closed="closed"
  >
    <div class="row7">
      <header class="modalHeader flex flexAlignS">
        <div class="title">
          <p>알림</p>
        </div>
        <button class="common-modal__close" @click="closed"></button>
      </header>
    </div>
    <div class="textareaContainer">
      등록하신 제품·서비스가 거절되었습니다.
    </div>
    <div class="modalFooterBtn btnBox" v-if="rejectNoties.length > 0">
      <!-- <router-link
        :to="
          rejectNoties[0].type === 'service'
            ? '/corp/productEnroll/' + rejectNoties[0].IDX
            : '/corp/serviceEnroll/' + rejectNoties[0].IDX
        "
        tag="button"
        class="redborderBtn"
        @click="closed"
        >확인하러가기</router-link
      > -->
      <button class="redborderBtn" @click="gotoPage">확인하러가기</button>
      <!-- <button class="redborderBtn" @click="onClickSave">확인하러가기</button> -->
      <button class="redBtn" @click="closed">취소</button>
    </div>
  </modal>
</template>

<script>
// import {mapActions} from 'vuex'

import { mapGetters } from "vuex";

export default {
  name: "ModalRejectAlarm",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters("auth", ["isAuth", "getUser", "getRejectNoties"]),
    rejectNoties: {
      get() {
        return this.getRejectNoties;
      },
    },
  },
  mounted() {
    // this.show();
  },
  methods: {
    closed() {
      this.$modal.hide("modal-reject-alarm");
    },

    gotoPage() {
      this.closed();
      const path =
        this.rejectNoties[0].type === "service"
          ? "/corp/productEnroll/" + this.rejectNoties[0].IDX
          : "/corp/serviceEnroll/" + this.rejectNoties[0].IDX;
      this.$router.push({ path: path });
    },

    onClickCancel() {
      this.hide();
    },
  },
};
</script>
<style scoped>
.customSurveyModal header button {
  padding: 0 0rem;
  width: 20px;
  height: 20px;
  background-image: url("~@/assets/images/icons/close.svg");
}
.textareaContainer {
  width: 100%;
  text-align: center;
  font-size: 2.4rem;
  font-weight: 500;
  padding: 0 4rem 2rem 4rem;
}
.textareaContainer textarea {
  width: 90%;
  text-align: center;
  font-size: 2.4rem;
  resize: none;
}
</style>
